import ItemComm from './itemComm.api';
import RetailItemComm from './RetailItemComm';
import RIXItemComm from './RixItemComm';
export default ItemComm;
export * from './itemComm.api';
export const ItemCommAdapters = {
    RetailItemComm,
    RIXItemComm,
};
